module.exports = __webpack_public_path__ + "static/series_500-14b833883c666d52ef5e911eb2e15371.png";